import React from "react";

import classNames from "classnames";

import styles from "./style.module.scss";

const PanelSection = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames(styles.section, className)}>{children}</div>
  );
};

export default PanelSection;
